import type { TFunction } from "i18next";

/** A server key's use this period, in words: "3 of 100 calls, 1200 of 50000 tokens", or "3 calls, …" without a budget. */
export function usageText(
  usage: { readonly period: string; readonly usedCalls: number; readonly usedTokens: number },
  budget: { readonly calls: number | null; readonly tokens: number | null },
  t: TFunction,
): string {
  const calls = budget.calls === null
    ? t("serverKeys.callsUsed", { count: usage.usedCalls })
    : t("serverKeys.callsOfLimit", { used: usage.usedCalls, count: budget.calls });
  const tokens = budget.tokens === null
    ? t("serverKeys.tokensUsed", { count: usage.usedTokens })
    : t("serverKeys.tokensOfLimit", { used: usage.usedTokens, count: budget.tokens });
  return t("serverKeys.usage", { period: usage.period || "—", calls, tokens });
}
